<header>
  <div class="card-wrapper">
    <mat-card *ngIf="app.state.error" class="error" color="accent">
      <h2>Technische Störung</h2>
      <div [innerHTML]="app.state.error">

      </div>
    </mat-card>

    <mat-card *ngIf="app.state.maintenance" class="maintenance">
      <h2>Wartungsarbeiten</h2>
      <div [innerHTML]="app.state.maintenance">

      </div>
    </mat-card>

    <mat-card class="logo">
      <a href="https://www.staatsanzeiger.de"></a>
    </mat-card>

    <mat-card class="stores">
      <mat-grid-list cols="11" rowHeight="50px">
        <mat-grid-tile colspan="3" rowspan="2">
          <img class="store-icon" src="assets/epaper-icon.png" />
        </mat-grid-tile>

        <mat-grid-tile colspan="8">
          <span class="teaser">
            Lesen Sie den Staatsanzeiger bequem auf Ihrem Smartphone oder Tablet.
          </span>
        </mat-grid-tile>

        <mat-grid-tile colspan="4">
          <a class="store-badge apple" href='https://apps.apple.com/de/app/staatsanzeiger-e-paper/id1489931048'
            target="_blank"><img alt='Laden in App Store'
              src='assets/Download_on_the_App_Store_Badge_DE_RGB_wht_092917.svg' /></a>
        </mat-grid-tile>

        <mat-grid-tile colspan="4">
          <a class="store-badge google" target="_blank"
            href='https://play.google.com/store/apps/details?id=de.staatsanzeiger.epaper&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img
              alt='Jetzt bei Google Play'
              src='https://play.google.com/intl/en_us/badges/static/images/badges/de_badge_web_generic.png' /></a>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card>


  </div>
</header>

<nav *ngIf="authed" class="{{ sideNavActive ? 'active': '' }}">
  <mat-card class="nav">
    <button mat-button (click)="sideNav.toggle(); sideNavActive = !sideNavActive" class="menu">
      <fa-icon [icon]="['fas', 'bars']" size="lg" class="burger"></fa-icon>
      <fa-icon [icon]="['fas', 'times']" size="lg" class="close"></fa-icon>
    </button>
    <h3>{{user.name}}</h3><br>
    <p>{{user.email}}</p>
    <fa-icon [icon]="['fas', 'user']" size="lg" class="float-right"></fa-icon>
  </mat-card>
</nav>

<div class="main">
  <mat-drawer-container class="container" hasBackdrop="false">
    <mat-drawer #sideNav class="side-nav" mode="over" autoFocus="false">
      <div (click)="sideNav.toggle(); sideNavActive = !sideNavActive">
        <button mat-menu-item routerLink="zugaenge">
          <fa-icon [icon]="['fas', 'users-cog']"></fa-icon>
          <span>Zugänge verwalten</span>
        </button>
        <button mat-menu-item routerLink="profil">
          <fa-icon [icon]="['fas', 'pen']"></fa-icon>
          <span>Profil bearbeiten</span>
        </button>
        <button mat-menu-item routerLink="neue-email">
          <fa-icon [icon]="['fas', 'at']"></fa-icon>
          <span>E-Mail-Adresse ändern</span>
        </button>
        <button mat-menu-item (click)="newPassword()">
          <fa-icon [icon]="['fas', 'key']"></fa-icon>
          <span>Passwort ändern</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <fa-icon [icon]="['fas', 'sign-out-alt']"></fa-icon>
          <span>Abmelden</span>
        </button>
      </div>
    </mat-drawer>

    <router-outlet></router-outlet>

  </mat-drawer-container>
</div>

<footer>
  <mat-card>
    <mat-grid-list cols="9" rowHeight="50px">
      <mat-grid-tile colspan="4" class="copyright">
        <span>&copy;</span>
        2025 - Staatsanzeiger für <br>Baden-Württemberg GmbH &amp; Co. KG
      </mat-grid-tile>
      <mat-grid-tile colspan="2"><a href="https://www.staatsanzeiger.de/impressum" target="_blank">Impressum</a>
      </mat-grid-tile>
      <mat-grid-tile colspan="2"><a href="https://www.staatsanzeiger.de/datenschutz" target="_blank">Datenschutz</a>
      </mat-grid-tile>
      <mat-grid-tile><a href="https://www.staatsanzeiger.de/agb" target="_blank">AGB</a></mat-grid-tile>
    </mat-grid-list>
  </mat-card>
</footer>
